/** @format */

import * as toast from './toast'

const fetch = window.fetch
// const {escape} = require('querystring')

function encodeFormData(data) {
  let urlEncodedDataPairs = []
  for (let name in data) {
    urlEncodedDataPairs.push(
      encodeURIComponent(name) + '=' + encodeURIComponent(data[name]),
    )
  }
  return urlEncodedDataPairs.join('&').replace(/%20/g, '+')
}

function encodeNestedUrlParams(queryObj, nesting = '') {
  let queryString = ''

  const pairs = Object.entries(queryObj).map(([key, val]) => {
    // Handle the nested, recursive case, where the value to encode is an object itself
    if (typeof val === 'object') {
      return encodeNestedUrlParams(val, nesting + `${key}.`)
    } else {
      // Handle base case, where the value to encode is simply a string.
      return [nesting + key, val].map(encodeURIComponent).join('=')
    }
  })
  return pairs.join('&')
}

export function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}

export default async function ajax({
  method = 'POST',
  json = true,
  endpoint,
  params,
  payload,
  onSuccess,
  onError,
  successMsg,
  errorMsg,
  encourageRetry,
}) {
  let body, resp
  try {
    let serializedPayload,
      url,
      headers = {'X-CSRF-TOKEN': getCookie('csrf_access_token')}

    if (json) {
      headers['Accept'] = 'application/json'
      headers['Content-Type'] = 'application/json'
      serializedPayload = payload && JSON.stringify(payload)
    } else {
      headers['Content-Type'] = 'application/x-www-form-urlencoded'
      serializedPayload = encodeFormData(payload)
    }

    const querystr = params && encodeNestedUrlParams(params)
    url = querystr ? endpoint + '?' + querystr : endpoint

    resp = await fetch(url, {
      method,
      credentials: 'same-origin',
      body: serializedPayload,
      headers,
    })
    if (resp.status === 204) {
      body = ''
    } else {
      body = json ? await resp.json() : await resp.text()
    }
    if (!resp.ok || body.errors || body.error) {
      const retryMsg =
        encourageRetry === true
          ? 'Please try again.'
          : encourageRetry === false
            ? 'Please contact support.'
            : ''

      // Handle 451 status code for blocked accounts
      if (resp.status === 451) {
        const blockedMsg =
          body.error ||
          'Your account has been blocked due to terms of service violation. Please contact support for further information.'
        toast.error(blockedMsg)
        onError && (await onError(body, resp))
        return
      }

      let finalErrMsg =
        errorMsg && (body.error || body.errors)
          ? `${errorMsg}: ${body.errors ? body.errors.join(', ') : body.error}`
          : errorMsg
      if (retryMsg && finalErrMsg) {
        finalErrMsg += `. ${retryMsg}`
      }
      finalErrMsg && toast.error(finalErrMsg)
      onError && (await onError(body, resp))
      return
    }
  } catch (e) {
    console.error(e || 'unknown exception')
    errorMsg &&
      toast.error(
        `${errorMsg}. <br>Unexpected error: if this error continues, please contact support.`,
        {timeout: 8000},
      )
    onError && (await onError(body, resp))
    return
  }

  successMsg &&
    toast.success(
      typeof successMsg === 'function' ? successMsg(body) : successMsg,
    )
  onSuccess && (await onSuccess(body))
}
